/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  IonPage,
  IonContent,
  IonLoading,
  IonAlert,
} from "@ionic/react";
import axios from "axios";
import React, { useState } from "react";
//  import { useNavigate } from "react-router-dom"; // Change from useHistory
import { useHistory } from "react-router-dom";
import { useAuthInit } from "../Auth";
import {
  requestID,
  baseUrl,
  setUserSession,
  config,
  APP_VERSION,
  APP_COPYRIGHT,
  setBusinessData,
} from "../common/utils";
import {
  Box,
  Button,
  Container,
  InputAdornment,
  Paper,
  Typography,
  Grid,
  Divider,
  useMediaQuery,
  useTheme as useMuiTheme,
  Alert,
  CircularProgress,
  Avatar,
  styled,
  FormControl,
  InputLabel,
  OutlinedInput,
  Link as MuiLink,
  createTheme,
  FormHelperText,
  IconButton,
} from "@mui/material";
import {
  LockOutlined,
  ArrowBack,
  Visibility,
  VisibilityOff,
  LocationOn,
  School,
} from "@mui/icons-material";
import { ThemeProvider } from "@emotion/react";

// ============================================
// Modern Dashboard Theme (MUI5) - Matching DeltaGovPortal
// ============================================
const theme = createTheme({
  palette: {
    primary: {
      main: "#243b5a", // deep navy from spec
    },
    background: {
      default: "#f4f6f8",
      paper: "#ffffff",
    },
    text: {
      primary: "#1f2937",
      secondary: "#6b7280",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2rem",
      fontWeight: 700,
      color: "#1f2937",
    },
    h4: {
      fontSize: "1.25rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "0.875rem",
      color: "#6b7280",
    },
    body2: {
      fontSize: "0.875rem",
      color: "#374151",
    },
    caption: {
      fontSize: "0.75rem",
      letterSpacing: "1px",
      color: "#6b7280",
      textTransform: "uppercase",
    },
    subtitle2: {
      fontSize: "0.875rem",
      fontWeight: 600,
      color: "#ffffff",
    },
  },
  shape: {
    borderRadius: 6,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          border: "1px solid #e5e7eb",
          boxShadow: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
          justifyContent: "space-between",
          padding: "12px 16px",
          borderRadius: 6,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "#d1d5db",
          borderWidth: "1px",
        },
      },
    },
  },
});

// ============================================
// Styled Components - Matching DeltaGovPortal
// ============================================
const Header = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  height: "90px",
  padding: "0 40px",
  display: "flex",
  alignItems: "center",
  width: "100%",
  boxSizing: "border-box",
}));

const LogoCircle = styled(Box)({
  width: "55px",
  height: "55px",
  borderRadius: "50%",
  backgroundColor: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "20px",
  color: "#243b5a",
  fontWeight: "bold",
  border: "2px solid #f0c45a",
  boxSizing: "border-box",
  marginRight: "16px",
});

const FooterLink = styled(MuiLink)({
  color: "#d1d5db",
  textDecoration: "underline",
  cursor: "pointer",
  "&:hover": {
    color: "#ffffff",
  },
});

const StyledCard = styled(Paper)({
  width: "450px",
  maxWidth: "100%",
  backgroundColor: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: "6px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  margin: "0 auto",
});

const LoginButton = styled(Button)({
  height: "45px",
  backgroundColor: "#243b5a",
  color: "#ffffff",
  fontWeight: 600,
  fontSize: "14px",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  borderRadius: "6px",
  padding: "0 16px",
  "&:hover": {
    backgroundColor: "#162c47",
  },
});

const StyledFormControl = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    height: "42px",
    backgroundColor: "#f9fafb",
    "& fieldset": {
      borderColor: "#d1d5db",
      borderRadius: "6px",
    },
    "&:hover fieldset": {
      borderColor: "#d1d5db",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#243b5a",
      borderWidth: "1px",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "13px",
    color: "#374151",
    fontWeight: 500,
    transform: "translate(12px, -8px) scale(0.85)",
    "&.Mui-focused": {
      color: "#374151",
    },
  },
  "& .MuiFormLabel-asterisk": {
    color: "#ef4444",
    marginLeft: "4px",
  },
});



  const businessData = [
  {
    id: 89,
    business_id: "bus_id_70ae56ac9543386d2de27671177764e1",
    branch_id: "bra_id_70ae56ac9543386d2de27671177764e1",
    entity_id: "entity_id_ef6581140b9e49002d722285259483d2",
    user_id: "58397318e4b86c5fb7ff_UIS10bjnGNCrjbwnzH2kFOkzG_CqNGzJ5s0TY9Vf2wU1eZ",
    bus_uuid: "SAAA003I",
    business_type_id: "1009",
    roleID: 30,
    name: "JEN PHOTO MASTER",
    email: "jenphotomaster71a@gmail.com",
    phone: "08034474505",
    address: "#6 Rasco avenue, Off Ehimare Street, Off Sapele road",
    status: 1,
    receipt_layout: "large",
    activationCode: "",
    collection_total_amount: "",
    position: "",
    size: "",
    slogan: "",
    target_cycle: "",
    targeted_savings_amount: "",
    url: "",
    created_at: "2025-07-29 10:54:04",
    last_updated: "2025-08-18 14:41:05"
  }
];
  setBusinessData(businessData);


// ============================================
// Main LoginSchool Component - Using local state and onClick
// ============================================
const LoginSchool: React.FC = () => {
  const [isInternet, setIsInternet] = useState({ openAlert: false, message: "" });
  const [status, setStatus] = useState({ loading: false, error: false });
  const authInitState = useAuthInit();
   const [userData, setUserData] = useState<any>(null);

   
 // const navigate = useNavigate(); // Change from useHistory

const history = useHistory();

  

  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));

  // Local state for form fields - initially empty
  const [lgaCode, setLgaCode] = useState("");
  const [schoolCode, setSchoolCode] = useState("");
  const [password, setPassword] = useState("");



  // Local state for field errors
  const [errors, setErrors] = useState({
    lgaCode: "",
    schoolCode: "",
    password: "",
  });

  // Password visibility
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  // Validate fields before login
  const validateFields = (): boolean => {
    const newErrors = {
      lgaCode: "",
      schoolCode: "",
      password: "",
    };
    let isValid = true;

    if (!lgaCode.trim()) {
      newErrors.lgaCode = "LGA Code is required";
      isValid = false;
    }

    if (!schoolCode.trim()) {
      newErrors.schoolCode = "School Code is required";
      isValid = false;
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Login handler - called directly from button onClick
//   const handleLogin = async () => {
//     // Validate fields first
//     if (!validateFields()) {
//       return;
//     }

//     setStatus({ loading: true, error: false });
// console.log(lgaCode, schoolCode, password);
//     // try {
//       const response = await axios.post(
//         baseUrl() + "schools/login",
//         {
//           lgaCode: lgaCode,
//           schoolCode: schoolCode,
//           password: password,
//           requestID: requestID(),
//         },
//         config
//       );
//       console.log({response})

//       if (response.data.status == true) {
//        const userDatax = response.data.data;
// console.log(userDatax);

// const userData = {
//   schoolCode: userDatax.schoolCode,
//   lgaCode: userDatax.lgaCode,
//   id: userDatax.id,
// };

// setUserSession(
//   `${userData.schoolCode}*${userData.lgaCode}*${userData.id}`,
//   userDatax
// );
 
//       //  authInitState.isLoggedIn = true;

//         // Navigate to school dashboard or appropriate page
//         history.push("/school_dashboard");
//         return;
//       }

//       setStatus({ loading: false, error: true });
//       setIsInternet({
//         openAlert: true,
//         message: response.data.message || "Login failed. Please check your credentials.",
//       });

//     // } catch (error: any) {
//     //   setStatus({ loading: false, error: true });
//     //           history.push("/school_dashboard");
//     //          // window.location.replace("/school_dashboard");

//     //   // setIsInternet({
//     //   //   openAlert: true,
//     //   //   message: error.response?.data?.message || "An error occurred during login.",
//     //   // });
//     // }
//   };
const handleLogin = async () => {
    if (!validateFields()) return;

    setStatus({ loading: true, error: false });

    
      const response = await axios.post(
        baseUrl() + "schools/login",
        {
          lgaCode: lgaCode,
          schoolCode: schoolCode,
          password: password,
          requestID: requestID(),
        },
        config
      );

      if (response.data.status == true) {
        const userDatax = response.data.data;

        const userData = {
          schoolCode: userDatax.schoolCode,
          lgaCode: userDatax.lgaCode,
          id: userDatax.id,
        };

        setUserSession(
          `${userData.schoolCode}*${userData.lgaCode}*${userData.id}`,
          userDatax
        );

        // Force auth state update
        authInitState.isLoggedIn = true;

      //  console.log("authInitState", authInitState);
       // return;
         setTimeout(() => {
          // Use history.push for v5
         history.push("/school_dashboard");
       //  window.location.href = "/school_dashboard";

        }, 1000);
        
        // Use navigate instead of history.push
      //  navigate("/school_dashboard", { replace: true });

        return;
      }

      setStatus({ loading: false, error: true });
      setIsInternet({
        openAlert: true,
        message: response.data.message || "Login failed. Please check your credentials.",
      });

   
    
  };
  // Handle return to main portal
  const handleReturnToMainPortal = () => {
  //  navigate("/login");
            window.location.href = "/login";

  };

  return (
    <ThemeProvider theme={theme}>
      <IonPage>
        <IonContent>
          {/* Full page layout */}
          <Box sx={{
            bgcolor: "background.default",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
          }}>
            {/* HEADER - Matching DeltaGovPortal */}
            <Header>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <LogoCircle>⚖️</LogoCircle>
                <Box>
                  <Typography variant="caption" sx={{ color: "#cbd5e1", letterSpacing: "0.5px", display: "block" }}>
                    DELTA STATE GOVERNMENT
                  </Typography>
                  <Typography variant="h6" sx={{ color: "#ffffff", fontWeight: 600, lineHeight: 1.2 }}>
                    Ministry of Primary Education
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#d1d5db" }}>
                    Official Portal
                  </Typography>
                </Box>
              </Box>
            </Header>

            {/* MAIN CONTENT - Centered Login Card */}
            <Box sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 2,
              py: { xs: 4, md: 6 },
            }}>
              <StyledCard>
                <Box sx={{ p: 3 }}>
                  {/* Title */}
                  <Typography variant="h4" sx={{ fontSize: "1.25rem", fontWeight: 600, color: "#1f2937", mb: 0.5 }}>
                    School Administration Portal
                  </Typography>

                  {/* Description */}
                  <Typography variant="body2" sx={{ color: "#6b7280", lineHeight: 1.5, mb: 2.5 }}>
                    Enter your LGA Code, School Code and password to access the portal.
                  </Typography>

                  {/* Divider */}
                  <Divider sx={{ mx: -3, mb: 2.5, borderWidth: 1 }} />

                  {/* Form - without onSubmit */}
                  <Box>
                    {/* LGA Code Field */}
                    <StyledFormControl fullWidth variant="outlined" sx={{ mb: 2.5 }}>
                      <InputLabel
                        htmlFor="lgaCode"
                        sx={{
                          fontSize: "13px",
                          color: "#374151",
                          fontWeight: 500,
                          '& .MuiFormLabel-asterisk': {
                            color: "#ef4444",
                            marginLeft: '4px',
                          }
                        }}
                      >
                        LGA Code <span style={{ color: "#ef4444", marginLeft: '4px' }}>*</span>
                      </InputLabel>
                      <OutlinedInput
                        id="lgaCode"
                        value={lgaCode}
                        onChange={(e) => {
                          setLgaCode(e.target.value);
                          // Clear error when user types
                          if (errors.lgaCode) {
                            setErrors({ ...errors, lgaCode: "" });
                          }
                        }}
                        placeholder="Enter LGA code"
                        error={!!errors.lgaCode}
                        startAdornment={
                          <InputAdornment position="start">
                            <LocationOn sx={{ color: "#9ca3af", fontSize: 20 }} />
                          </InputAdornment>
                        }
                        sx={{
                          height: "42px",
                          backgroundColor: "#f9fafb",
                          fontSize: "14px",
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: "#d1d5db",
                            borderRadius: "6px",
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: "#d1d5db",
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: "#243b5a",
                            borderWidth: "1px",
                          },
                        }}
                      />
                      {errors.lgaCode && (
                        <FormHelperText error>{errors.lgaCode}</FormHelperText>
                      )}
                    </StyledFormControl>

                    {/* School Code Field */}
                    <StyledFormControl fullWidth variant="outlined" sx={{ mb: 2.5 }}>
                      <InputLabel
                        htmlFor="schoolCode"
                        sx={{
                          fontSize: "13px",
                          color: "#374151",
                          fontWeight: 500,
                          '& .MuiFormLabel-asterisk': {
                            color: "#ef4444",
                            marginLeft: '4px',
                          }
                        }}
                      >
                        School Code <span style={{ color: "#ef4444", marginLeft: '4px' }}>*</span>
                      </InputLabel>
                      <OutlinedInput
                        id="schoolCode"
                        value={schoolCode}
                        onChange={(e) => {
                          setSchoolCode(e.target.value);
                          // Clear error when user types
                          if (errors.schoolCode) {
                            setErrors({ ...errors, schoolCode: "" });
                          }
                        }}
                        placeholder="Enter school code"
                        error={!!errors.schoolCode}
                        startAdornment={
                          <InputAdornment position="start">
                            <School sx={{ color: "#9ca3af", fontSize: 20 }} />
                          </InputAdornment>
                        }
                        sx={{
                          height: "42px",
                          backgroundColor: "#f9fafb",
                          fontSize: "14px",
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: "#d1d5db",
                            borderRadius: "6px",
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: "#d1d5db",
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: "#243b5a",
                            borderWidth: "1px",
                          },
                        }}
                      />
                      {errors.schoolCode && (
                        <FormHelperText error>{errors.schoolCode}</FormHelperText>
                      )}
                    </StyledFormControl>

                    {/* Password Field with Eye Icon */}
                    <StyledFormControl fullWidth variant="outlined" sx={{ mb: 2.5 }}>
                      <InputLabel
                        htmlFor="password"
                        sx={{
                          fontSize: "13px",
                          color: "#374151",
                          fontWeight: 500,
                          '& .MuiFormLabel-asterisk': {
                            color: "#ef4444",
                            marginLeft: '4px',
                          }
                        }}
                      >
                        Password <span style={{ color: "#ef4444", marginLeft: '4px' }}>*</span>
                      </InputLabel>
                      <OutlinedInput
                        id="password"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          // Clear error when user types
                          if (errors.password) {
                            setErrors({ ...errors, password: "" });
                          }
                        }}
                        placeholder="Enter password"
                        error={!!errors.password}
                        startAdornment={
                          <InputAdornment position="start">
                            <LockOutlined sx={{ color: "#9ca3af", fontSize: 20 }} />
                          </InputAdornment>
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              edge="end"
                              sx={{ color: "#9ca3af" }}
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        }
                        sx={{
                          height: "42px",
                          backgroundColor: "#f9fafb",
                          fontSize: "14px",
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: "#d1d5db",
                            borderRadius: "6px",
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: "#d1d5db",
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: "#243b5a",
                            borderWidth: "1px",
                          },
                        }}
                      />
                      {errors.password && (
                        <FormHelperText error>{errors.password}</FormHelperText>
                      )}
                    </StyledFormControl>

                    {/* Submit Button - using onClick instead of type="submit" */}
                    <LoginButton
                      onClick={handleLogin}
                      fullWidth
                      disabled={status.loading}
                    >
                      {status.loading ? <CircularProgress size={20} sx={{ color: "white" }} /> : "ACCESS SCHOOL PORTAL"}
                    </LoginButton>

                    {/* Divider */}
                    <Divider sx={{ my: 2, borderWidth: 1 }} />

                    {/* Return Link */}
                    <Button
                      onClick={handleReturnToMainPortal}
                      startIcon={<ArrowBack sx={{ fontSize: 18 }} />}
                      sx={{
                        color: "#243b5a",
                        fontSize: "13px",
                        textTransform: "none",
                        p: 0,
                        '&:hover': {
                          textDecoration: "underline",
                          backgroundColor: "transparent",
                        },
                      }}
                    >
                      Return to main portal
                    </Button>
                  </Box>
                </Box>
              </StyledCard>
            </Box>

            {/* Disclaimer */}
            <Typography
              variant="caption"
              sx={{
                fontSize: "0.75rem",
                color: "#9ca3af",
                textAlign: "center",
                maxWidth: "500px",
                mx: "auto",
                px: 2,
                mb: 2,
                display: "block",
              }}
            >
              This is a restricted access portal. Unauthorized access attempts are logged and may be subject to legal action.
            </Typography>

            {/* FOOTER - Matching DeltaGovPortal exactly */}
            <Box component="footer" sx={{ bgcolor: "primary.main", color: "#d1d5db", py: { xs: 5, md: 6 }, mt: "auto" }}>
              <Container maxWidth="lg">
                <Grid container spacing={4} sx={{ mb: 4 }}>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" sx={{ color: "#ffffff", fontWeight: 600, mb: 2 }}>
                      MINISTRY OF PRIMARY EDUCATION
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#d1d5db", mb: 0.5 }}>
                      Delta State Government
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#d1d5db", mb: 0.5 }}>
                      Ministry of Primary Education
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#d1d5db" }}>
                      Asaba, Delta State, Nigeria
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" sx={{ color: "#ffffff", fontWeight: 600, mb: 2 }}>
                      CONTACT INFORMATION
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#d1d5db", mb: 0.5 }}>
                      Email: info@dsgmope.ng
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#d1d5db", mb: 0.5 }}>
                      Address: Ministry Secretariat, Asaba
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#d1d5db" }}>
                      Telephone: +234 (0)901 234 5678
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" sx={{ color: "#ffffff", fontWeight: 600, mb: 2 }}>
                      OFFICIAL RESOURCES
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                      <FooterLink href="#">www.dsgmope.ng</FooterLink>
                    </Typography>
                    <Typography variant="body2">
                      <FooterLink href="#">Delta State Government Portal</FooterLink>
                    </Typography>
                  </Grid>
                </Grid>

                <Divider sx={{ borderColor: "rgba(255,255,255,0.2)", my: 3 }} />

                <Typography
                  variant="body2"
                  align="center"
                  sx={{ color: "rgba(255,255,255,0.7)", fontSize: "0.75rem", maxWidth: 900, mx: "auto", mb: 2 }}
                >
                  OFFICIAL NOTICE: This is an official portal of the Delta State Government, Ministry of Primary Education. Unauthorized access, misuse, or tampering with this system is prohibited and may be subject to legal action. All information provided is for official purposes only.
                </Typography>

                <Typography variant="body2" align="center" sx={{ color: "rgba(255,255,255,0.7)", fontSize: "0.75rem" }}>
                  © 2026 Delta State Government, Ministry of Primary Education. All rights reserved.
                </Typography>
              </Container>
            </Box>
          </Box>

          {/* Loading & Alert */}
          <IonLoading isOpen={status.loading} message="Authenticating..." />
          <IonAlert
            isOpen={isInternet.openAlert}
            header="Login Alert"
            message={isInternet.message}
            buttons={['OK']}
            onDidDismiss={() => setIsInternet({ openAlert: false, message: "" })}
          />
        </IonContent>
      </IonPage>
    </ThemeProvider>
  );
};

export default LoginSchool;